import Vue from 'vue'
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls'
import saltedSha1 from 'salted-sha1'

Vue.use(Vuex)
const userAgent = navigator.userAgent.replace(/\s/g, '');
const salt = navigator.buildID + String(navigator.oscpu).replace(/\s/g, '');
const key = saltedSha1(userAgent, salt)
let ls = new SecureLS({encodingType: 'des', isCompression: false, encryptionSecret: key});

if(window.location.href == 'https://idehgate.ir/#/repair'){
	localStorage.clear();
}


export default new Vuex.Store({
	state: {
		sidebarShow: 'responsive',
		sidebarMinimize: false,
		token: null,
		user_id: null,
		user_name: null,
		perms: null,
		verif: null,
		expires: null,
		notifications: [],
		send_sms_count: [],
		rcv_sms_count: [],
		in_queue_sms_count: [],
		created_at: [],
		get_chart: false,
		u_id: null,
		alert: null,
		socket: 0,
		connect: false,
		on_open: false,
		on_close: true,
	},
	mutations: {
		toggleSidebarDesktop (state) {
			const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
			state.sidebarShow = sidebarOpened ? false : 'responsive'
		},
		toggleSidebarMobile (state) {
			const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
			state.sidebarShow = sidebarClosed ? true : 'responsive'
		},
		set (state, [variable, value]) {
			state[variable] = value
		},
		set_token(state, token){
			state.token = token;
		},
		set_user_id(state, user_id){
			state.user_id = user_id;
		},
		set_user_name(state, user_name){
			state.user_name = user_name;
		},
		set_perms(state, perms){
			state.perms = perms;
		},
		set_verif(state, verif){
			state.verif = verif;
		},
		set_expires(state, expires){
			state.expires = expires;
		},	
		set_notifications(state, notifications){
			state.notifications.unshift(notifications);
		},
		rest_send_sms_count(state, send_sms_count){
			state.send_sms_count.unshift(send_sms_count);
		},
		rest_rcv_sms_count(state, rcv_sms_count){
			state.rcv_sms_count.unshift(rcv_sms_count);
		},
		rest_in_queue_sms_count(state, in_queue_sms_count){
			state.in_queue_sms_count.unshift(in_queue_sms_count);
		},
		rest_created_at(state, created_at){
			state.created_at.unshift(created_at);
		},
		empty_chart(state){
			state.send_sms_count = [];
			state.rcv_sms_count = [];
			state.in_queue_sms_count = [];
			state.created_at = [];
		},
		set_get_chart(state){
			state.get_chart = true;
		},
		socket_send_sms_count(state, send_sms_count){
			state.send_sms_count.shift();
			state.send_sms_count.push(send_sms_count);
		},
		socket_rcv_sms_count(state, rcv_sms_count){
			state.rcv_sms_count.shift();
			state.rcv_sms_count.push(rcv_sms_count);
		},
		socket_in_queue_sms_count(state, in_queue_sms_count){
			state.in_queue_sms_count.shift();
			state.in_queue_sms_count.push(in_queue_sms_count);
		},
		socket_created_at(state, created_at){
			state.created_at.shift();
			state.created_at.push(created_at);
		},
		set_u_id(state, u_id){
			state.u_id = u_id;
		},
		set_alert(state, alert){
			state.alert = alert;
		},
		set_connect(state, connect){
			state.connect = connect;
		},
		set_on_open(state, on_open){
			state.on_open = on_open;
		},
		set_on_close(state){
			state.on_close = false;
		},
		socket_connect(state){
			state.socket = new WebSocket("wss://idehgate.ir/ws", state.token.slice(7));
		},
		socket_close(state){
			state.socket.close();
		},
		reset(state) {
			state.sidebarShow = 'responsive';
			state.sidebarMinimize = false;
			state.token = null;
			state.user_id = null;
			state.user_name = null;
			state.perms = null;
			state.verif = null;
			state.expires = null;
			state.notifications = [];
			state.send_sms_count = [];
			state.rcv_sms_count = [];
			state.in_queue_sms_count = [];
			state.created_at = [];
			state.get_chart = false;
			state.u_id = null;
			state.alert = null;
			state.socket = 0;
			state.connect = false;
			state.on_open = false;
		}
	},
	plugins: [createPersistedState({
		storage: {
			getItem: key => ls.get(key),
			setItem: (key, value) => ls.set(key, value),
			removeItem: key => ls.remove(key)
		}
	})],
});